export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.title    = json.title
      this.schedule = json.schedule
      this.delta = json.delta
      this.box      = json.box

      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries


    },

  }
}